import { AccountDistributionData, ChartValue } from '../../services/dashboard.types';

export const transformBalanceHistory = (data: ChartValue[]) => {
    return data.map((item) => ({
        date: item.time * 1000, // Convert seconds to milliseconds for JavaScript Date
        balance: parseFloat(item.value),
    }));
};

export const balanceCheckOk = (data: AccountDistributionData): boolean => {
    return Math.abs(data.imported_quantity - data.quantity) < 0.0000001;
};
